import React from "react";

function HomeDashboardIcon(props) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.875 17.4171V18.0421H5.5H8.5674H9.1924V17.4171V12.595H12.8076V17.4171V18.0421H13.4326H16.5H17.125V17.4171V9.16706V8.85536L16.876 8.66783L11.376 4.52518L11 4.24196L10.624 4.52518L5.12398 8.66783L4.875 8.85536V9.16706V17.4171ZM17.25 8.79142V18.1671H12.6826V13.345V12.72H12.0576H9.9424H9.3174V13.345V18.1671H4.75V8.79142L11 4.08788L17.25 8.79142Z"
        fill="#121212"
        stroke="#EEEEEE"
        stroke-width="1.25"
      />
    </svg>
  );
}

export default HomeDashboardIcon;
